import merge from 'lodash/merge'
import { images as defaultImages } from 'merchants/identance/images'
import logo from './logo.svg';
import mobileAppQR from './mobile-app-qr.png';

export const images = merge({}, defaultImages, {
  logo,
  mobileAppQR
});

